
const isAllowedMimeType = (attachedFiles, allowedMimeTypes) => attachedFiles
    .every(element => allowedMimeTypes.includes(element.uploadedFile.type));

export default isAllowedMimeType;
